import React, { FunctionComponent, useCallback, useMemo } from 'react';

import { TooltipStateful } from '@yandex-360/orb-components/dist/components/Tooltip';
import cn from 'classnames';

import { Button } from '../../../../shared/components';
import SvgImage from '../../../../shared/components/svg-image';
import css from './styles.css';
import { ShareButtonProps } from './types';

const ShareButton: FunctionComponent<ShareButtonProps> = ({
    iconName,
    href,
    className,
    tooltip,
    iconClassName,
    testId,
    hideButtons,
}) => {
    const icon = useMemo(() => {
        return <SvgImage noContainer className={iconClassName} imageName={iconName} />;
    }, [iconClassName, iconName]);

    const handleClick = useCallback(() => {
        // Убираем блок с поделением без анимации
        // Без settimeout при возврате на страницу показывается анимация
        if (hideButtons) {
            setTimeout(hideButtons, 0);
        }
    }, [hideButtons]);

    return (
        <TooltipStateful content={tooltip} trigger="hover">
            <div>
                <Button
                    className={cn(css.ShareButton, className)}
                    view="neutral"
                    size="md"
                    elementType="a"
                    href={href}
                    target="_blank"
                    testId={testId}
                    icon={icon}
                    onClick={handleClick}
                />
            </div>
        </TooltipStateful>
    );
};

export default ShareButton;
